import { Component, OnInit } from '@angular/core';
import { RestService } from '@app/_services/rest.service';
import { first } from 'rxjs/operators';
import { AccountService, AlertService } from '@app/_services';
import { File } from '../../_models/file';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-shared-files',
  templateUrl: './shared-files.component.html',
  styleUrls: ['./shared-files.component.scss']
})

export class SharedFilesComponent implements OnInit {
  isLoading = false;
  files: File[] = [{ fileName: '', blobPath: '' }];
  displayedColumns: string[] = ['fileName', 'view', 'download'];
  containerName = "proplab-portal-files";
  folderName = '';
  constructor(private restService: RestService, 
    private alertService: AlertService,
    private route:ActivatedRoute,
    public accountService: AccountService) {
  }

  ngOnInit() {
    this.folderName = this.route.snapshot.params['refNo'];
    this.getAllClaimFiles();
  }

  getAllClaimFiles(){
    this.isLoading = true;
    this.restService.getClaimFiles(this.containerName, this.folderName)
      .pipe(first())
      .subscribe(files => {
        this.files = files;
        this.isLoading = false;
      },
        error => {
          this.alertService.error(error);
          this.isLoading = false;
        });
  }

  displayOrDownloadFile(fileName: string, blobPath: string, view?: boolean) {
    this.isLoading = true;
    if (fileName) {
      if(view)
      {
        this.restService.viewFile(blobPath, this.containerName);
      }
      else{
        this.restService.downloadFile(blobPath, this.containerName);
      }
    }
    this.isLoading = false;
  
  }
}